<template>
  <v-container>
    <div>
      <ContactDialog/>
    </div>
  </v-container>
</template>

<script>
  import ContactDialog from '@/components/dialogs/ContactDialog.vue';
  export default {
    name: 'Contact',
    components: {
      ContactDialog
    },
    created () {
      this.$store.commit('authentication/setDisplayContactDialog', true);
    },
  }
</script>

<style lang="scss">
</style>